<template>
    <div>
        <CCard class="p-2" style="border:none;">
            <CRow class="m-2">
                <CCol sm="12" md="4" lg="3" class="text-center p-2" v-for="button in buttons" :key="button.value">
                    <div :class="{'blue-background': activeButton === button.value, 'blue-text': activeButton !== button.value}" @click="setActiveButton(button.value)" class="p-2">
                        <img style="max-width:20px" class="mr-2" /> {{ button.label }}
                    </div>
                </CCol>
                <CCol sm="12" v-if="activeButton === 'TimeOffReport'">
                    <CRow>
                        <CCol sm="2" class="mt-4">
                            <label class="custom-14px-500 font-color-171717">Date Period</label>
                            <CInput type="date" v-model.lazy="SearchQuery" @change="applyFilter()" />
                        </CCol>
                        <CCol sm="2" class="mt-4">
                            <label class="custom-14px-500 font-color-171717">Department</label>
                            <v-select type="text" v-model.lazy="SearchQuery" @change="applyFilter()" />
                        </CCol>
                        <CCol sm="2" class="mt-4">
                            <label class="custom-14px-500 font-color-171717">Employee</label>
                            <v-select type="text" v-model.lazy="SearchQuery" @change="applyFilter()" />
                        </CCol>
                        <CCol sm="2" class="mt-4">
                            <label class="custom-14px-500 font-color-171717">Time Off Type</label>
                            <v-select type="text" v-model.lazy="SearchQuery" @change="applyFilter()" />
                        </CCol>
                        <CCol sm="2" class="mt-4">
                            <label class="custom-14px-500 font-color-171717">Time Off Status</label>
                            <v-select type="text" v-model.lazy="SearchQuery" @change="applyFilter()" />
                        </CCol>
                    </CRow>
                </CCol>
            </CRow>
        </CCard>
        <CCard class="p-2 custom-border-radius-16px" style="border:none;">
                <div>
                    <div class="p-2">
                        <CCard class="p-2 custom-border-radius-16px" style="border:none;">
                            <div v-if="activeButton === 'TimeOffApproval'">
                                <div>
                                    <CCol sm="12" md="4" lg="3" style="float:left">
                                        <div>
                                            <CRow>
                                                <CCol sm="12" class="d-flex font-color-171717">
                                                    <label class="m-2">Show </label><select v-model="perPage" id="entries" class="form-control">
                                                        <option :value="10">10</option>
                                                        <option :value="25">25</option>
                                                        <option :value="50">50</option>
                                                        <option :value="100">100</option>
                                                    </select> <label class="m-2">entries </label>
                                                </CCol>
                                            </CRow>
                
                
                                        </div>
                                    </CCol>
                                    <CCol sm="12" md="4" lg="3" style="float:right">
                                        <div>
                                            <CRow>
                                                <CCol sm="2" class="mb-2">
                                                    <img :src="require('@/assets/img/printer.png')" alt="View" style="cursor: pointer;width:30px" class="ml-2" />
                                                </CCol>
                                                <CCol sm="10" class="mb-2">
                                                    <CInput type="text" placeholder="Search...." v-model.lazy="SearchQuery" @change="applyFilter()" />
                                                </CCol>
                                            </CRow>
                
                
                                        </div>
                                    </CCol>
                                    <br /><br /><br />
                
                
                
                
                                                    </div>
                            </div>
                            <div v-if="activeButton === 'TimeOffReport'">
                                                    <div>
                                    <CCol sm="12" md="4" lg="3" style="float:left">
                                        <div>
                                            <CRow>
                                                <CCol sm="12" class="d-flex font-color-171717">
                                                    <label class="m-2">Show </label><select v-model="perPage" id="entries" class="form-control">
                                                        <option :value="10">10</option>
                                                        <option :value="25">25</option>
                                                        <option :value="50">50</option>
                                                        <option :value="100">100</option>
                                                    </select> <label class="m-2">entries </label>
                                                </CCol>
                                            </CRow>
                
                
                                        </div>
                                    </CCol>
                                    <CCol sm="12" md="4" lg="3" style="float:right">
                                        <div>
                                            <CRow>
                                                <CCol sm="2" class="mb-2">
                                                    <img :src="require('@/assets/img/printer.png')" alt="View" style="cursor: pointer;width:30px" class="ml-2" />
                                                </CCol>
                                                <CCol sm="10" class="mb-2">
                                                    <CInput type="text" placeholder="Search...." v-model.lazy="SearchQuery" @change="applyFilter()" />
                                                </CCol>
                                            </CRow>
                
                
                                        </div>
                                    </CCol>
                                    <br /><br /><br />
                
                
                
                
                                                    </div>
                            </div>
                            <div v-if="activeButton === 'TimeOffSummary'">
                                                    <div>
                                    <CCol sm="12" md="4" lg="3" style="float:left">
                                        <div>
                                            <CRow>
                                                <CCol sm="12" class="d-flex font-color-171717">
                                                    <label class="m-2">Show </label><select v-model="perPage" id="entries" class="form-control">
                                                        <option :value="10">10</option>
                                                        <option :value="25">25</option>
                                                        <option :value="50">50</option>
                                                        <option :value="100">100</option>
                                                    </select> <label class="m-2">entries </label>
                                                </CCol>
                                            </CRow>
                
                
                                        </div>
                                    </CCol>
                                    <CCol sm="12" md="4" lg="3" style="float:right">
                                        <div>
                                            <CRow>
                                                <CCol sm="2" class="mb-2">
                                                    <img :src="require('@/assets/img/printer.png')" alt="View" style="cursor: pointer;width:30px" class="ml-2" />
                                                </CCol>
                                                <CCol sm="10" class="mb-2">
                                                    <CInput type="text" placeholder="Search...." v-model.lazy="SearchQuery" @change="applyFilter()" />
                                                </CCol>
                                            </CRow>
                
                
                                        </div>
                                    </CCol>
                                    <br /><br /><br />
                                                    </div>
                            </div>
                        </CCard>
                    </div>
                </div>
        </CCard>

        <div v-if="OpenAddDocument" class="popup-all backdrop-all">
            <div class="popup-all2">
                <CRow>
                    <CCol sm="10">
                        <h3 class="custom-24px-600 font-color-171717 text-left">Add Document</h3>
                    </CCol>
                    <CCol sm="2" class="text-right">
                        <img src="../assets/img/close.png" style="max-width:50px;" @click="closePopupAddDocument" /></CCol>
                </CRow>
    
                <CCol sm="12" class="p-0">
                    <div class="p-2">
                        <CRow>
                            <CCol sm="12">
                                <CRow>
                                    <CCol sm="12">
                                        <h3 class="custom-14px-500 font-color-171717">File Name</h3>
                                        <CInput type="text" v-model="FullName" />
                                    </CCol>
                                    <CCol sm="12">
                                        <h3 class="custom-14px-500 font-color-171717">Remarks</h3>
                                        <CInput type="text" v-model="ShortName" />
                                    </CCol>
                                </CRow>
                            </CCol>
                            <CCol sm="12">
                                        <h3 class="custom-14px-500 font-color-171717">File Upload</h3>
                                <div class="text-center p-1">
                                    
                                    <CCard>
                                        <div class="text-center">
                                            <br /><br />
                                            <img src="../assets/img/upload1.png" style="max-width:50px;"/>
                                            <img :src="LogoPath" style="max-width:150px" v-if="filePreview == null" />
    
                                            <img :src="filePreview" style="max-width: 100px; cursor: pointer;" @click="triggerFileInput" />
                                            <input type="file" ref="fileInput" @change="onFileChange" style="display: none;" />
                                            <p class="font-color-0B63F6" @click="triggerFileInput">Click to upload or drag and drop </p>
                                            <p class="font-color-98A2B3">SVG, PNG, JPG, or GIF (max. 800x400px)</p>
    
                                            <!-- Display the file name if an image is not uploaded -->
                                            <p v-if="fileName" class="mt-2 mb-5">{{ fileName }}</p>
                                        </div>
    
    
                                    </CCard>
                                </div>
                            </CCol>
                        </CRow>
                        <div class="text-right">
                            <CButton class="p-2 text-center bg-0B63F6 text-white border-radius-half custom-button-padding" @click="SubmitCompany">
                                Save Changes</CButton>
                        </div>
                        <br />
    
                    </div>
                </CCol>
            </div>
        </div>
        <div v-if="isPopupSuccess" class="popup-all backdrop-all">
            <div class="popup-all1">
                <!-- Popup content -->
                <div class="text-center">
                    <img style="max-width: 300px" src="../assets/img/successPopup.png" />
                    <h3 class="custom-28px-500 font-color-171717 text-center mt-3">
                        Your data has been submitted successfully.
                    </h3>
                    <CButton class="custom-border-purple mt-4 text-white" @click="closeSuccess" style="width:100px"><span class="ml-2 mr-2">OK</span></CButton>
                </div>
            </div>
        </div>
    
    </div>
</template>


<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);
import _ from "lodash";


import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import VueCal from 'vue-cal';
import 'vue-cal/dist/vuecal.css';


export default {

    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout,
        VueCal

    },

    data() {
        return {
            user: {},
            detailStaff: {},
            columns: [
                'Name',
                'Relation',
                'Age',
                'Phone',
                'Action'
            ],
            allTableData: [
            ],
            options: {
                perPage: 5,
                pagination: false,
                searchable: false,
                filterable: false,
            },
            isPopupSuccess: false,
            OpenAddDocument: false,
            activeButton: 'TimeOffApproval', // Default active button
            buttons: [
                { value: 'TimeOffApproval', label: 'TimeOff Approval'},
                { value: 'TimeOffReport', label: 'TimeOff Report'},
                { value: 'TimeOffSummary', label: 'TimeOff Summary'},
            ],
            //For pagination
            perPage: "",
            currentPage: 1,
            pageSize: 5,
            totalPages: 10,
            filteredListStaffTableData: [],
            SearchQuery: "",
            hasNextPage: "",

        }





    },
    async mounted() {
        await this.GetListDetailStaff();
        await this.GetInfoUser();

    },

    computed: {

    },
    methods: {
        async GetInfoUser() {
            try {
                const response = await this.$API.get(this.$LoginUserDetail, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.user = response.data;
                    console.log("userInfo", this.user);
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        GoToPage() {
            let path = this.$router.currentRoute.path;
            if (path.toLowerCase() != "/Login") {

                this.$router.push({
                    path: '/Login',
                    query: {
                        targetUrl: this.$router.currentRoute.fullPath,
                    }
                })

            }
        },
        async GetListDetailStaff(id) {
            try {
                console.log("id" + id);
                const response = await this.$API.get(this.$GetStaffDetails + "?id=" + this.$route.query.id, {
                    withCredentials: true,
                });
                if (response.status === 200) {

                    this.detailStaff = response.data;

                } else {
                    console.error("Failed to fetch information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
            }
        },
        openAddDocument() {
            this.OpenAddDocument = true;
        },
        closeSuccess() {
            this.isPopupSuccess = false;
            this.OpenAddDocument = false;
        },
        closePopupAddDocument() {
            this.OpenAddDocument = false;
        },
        setActiveButton(buttonValue) {
            this.activeButton = buttonValue;
        },


    }

};
</script>